/**
 * Height options for the Layout page block.
 */
export const LAYOUT_MIN_HEIGHT_PRESETS = {
  XS: '96px',
  S: '216px',
  M: '340px',
  L: '480px',
  XL: '620px'
};